import React from 'react';
import {ArrowThickRight} from './icons';
import Link from '../utils/link';
import parse from 'html-react-parser';
import Arrow from '../assets/images/arrow-09.png'
import Fade from 'react-reveal/Fade';

const Resources = ({items, title}) => {
  return (
    <section className='resources'>
      <Fade bottom distance='40px'>
        <div className='resources__inner'>
          <div className='resources__title'>
            {title && <h1>{parse(title)}</h1>}
            <div className='arrow'>
              <img loading='lazy' src={Arrow} alt="arrow"/>
            </div>
          </div>
          <div className='resources__items'>
            {
              items?.length > 0 && items.map((el, i) => (
                <Link to={el.uri} key={i} className='resources__item'>
                  <div className='resources__item-title'>
                    {el.acf.label && <span>{el.acf.label}</span>}
                    {el.title && <h3>{el.title}</h3>}
                  </div>
                  <div className='resources__item-content'>
                    {el.acf.excerpt && <p>{el.acf.excerpt}</p>}
                    <div className='arrow'>
                      <button><ArrowThickRight/></button>
                    </div>
                  </div>
                </Link>
              ))
            }
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Resources